// extracted by mini-css-extract-plugin
export default {"footer":"footer-module___footer___d225c706","footerCancel":"footer-module___footerCancel___cabe2098","smallText":"footer-module___smallText___c445abd9"};